export default "__VITE_ASSET__CERhloLD__";